<template>
<!-- miw:1200px; -->
    <div :class="[ shit$(`w:100%; miw:676px; h:100%; absolute; top; left; bgc:#fff; z:1999; dis:f;`), ]">
        <section :class="[  'autoAdaption', 'guideImg', shit$(`background-image: url(${env$}static/images/img_user_type_family.png);`)]">
            <img :src="`${env$}static/images/logo_nuwa.png`" :class="shit$(`w:102px; relative; top:60px; left:60px;`)"/>
            <div :class="shit$(`relative; top:334px; left:60px; w:276px;s`)">
                <h3 :class="shit$(`c:#fff100; font:24px;`)">{{ this.$t("code-lab/component/login-guide/login-guide.vue_2") }}</h3>
                <p :class="shit$(`font:32px; c:#fff; lh:1.4;`)">{{ this.$t('code-lab/component/login-guide/login-guide.vue_3') }}</p>
            </div>
        </section>
        <section :class="shit$(`w:573px; margin:0 auto; pt:220px; text-a:c;`)">
            <h3 :class="shit$(`font:18px; c:#333; h:27px; lh:27px;`)">{{this.$t( "code-lab/component/login-guide/login-guide.vue_0" ) }}</h3>
            <div :class="shit$(`my:30px; dis:f; justify-c:sb;`)">
                <template v-for="(o, i) in arr">
                    <section :key="i" :class="[o.is && shit$(`c:#00b5e2!; bc:#00b5e2!; font-w:500;`), typeIsString(o.is) && shit$('cursor:n; bc:#dcdfe6; bgc:#f5f7fa;'),
                    shit$(`w:180px; h:157px; b:1px; font:14px; py:15px; dis:f; align-i:c; flex-d:c; justify-c:sa;  radius:4px;`)]">
                        <el-radio class="guideImgRadio" :disabled="typeIsString(o.is)" fill="#00b5e2;" v-model="radio" :label="o.name"></el-radio>
                        <img :src="`${env$}static/images/guide/icon_user_type_${o.name}.png`" :class="shit$(`w:50px;`)"/>
                        <p :class="typeIsString(o.is) && shit$(`opacity:0.8;`)">{{ o.label }}</p>
                    </section>
                </template>
            </div>
            <el-button @click="() => arr.find(fo => fo.name === radio) && arr.find(fo => fo.name === radio).link && (location.href = arr.find(fo => fo.name === radio).link)" :class="shit$(`p:0px; w:182px; radius:4px; bgc:#00b5e2!; c:#fff!; border:none; hover:opacity:0.6; active:opacity:1;`)">
                <span :class="shit$(`dis:b; h:40px; lh:40px; font:16px!; font-w:500; letter-s:1.07px; c:#fff;`)">{{this.$t( "code-lab/component/login-guide/login-guide.vue_1" ) }}</span>
            </el-button>
        </section>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const Cookies = window.Cookies;
export default {
    data: () => ({
       arr: [],
       radio: 'codeLab'
    }),
    computed: {
        ...mapState(['env$', 'multiLanguageStoreMp'])
    },
    methods: {
        typeIsString (tg) { return typeof tg === 'string' }
    },
    created () {
        this.location = window.location
        this.http$('get', '/uams/scope', { name: 'codeLab' })
        .then(res => {
            const lang = Cookies.get("langCode") || 'zh-TW'
            if (res.data && res.data.status && Number(res.data.status.code) === 0) {
                const t = res.data.data
                this.arr = t.map(({ i18n, link, name }) => ({
                    label: i18n.find(fo => fo.langCode === lang).title,
                    link,
                    name,
                    is: ['codeLab','codeLab_student','codeLab_teacher'].includes(name) || ''
                }))
            }
        })
        .catch(err => {
            console.err(err)
        })
    },
}
</script>

<style lang="scss">
.guideImgRadio {
    .el-radio__input.is-disabled .el-radio__inner{
        border-color: #E4E7ED!important;
    }
    .el-radio__input.is-checked .el-radio__inner {
        border-color: #00b5e2;
        background: #00b5e2;
    }
    .el-radio__inner:hover {
        border-color: #00b5e2;
    }
    .el-radio__label {
        display: none;
    }
}

</style>

<style scoped>
    @media screen and (max-width: 1200px) {
        .autoAdaption {
            display: none;
        }
    }

</style>

<style lang="scss" scoped>
    .guideImg {
        min-width: 436px;
        width: 34%;
        height: 100%;
        background-size: cover;
    }
    .el-radio {
        margin-right: 0px!important;
    }
</style>

